var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TheFooterMenu"},[_c('nav',[_c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item.target},[(item.url !== '#')?_c('a',{attrs:{"href":item.url,"target":"_blank"},domProps:{"textContent":_vm._s(item.text)}}):_c('router-link',{attrs:{"to":{ name: 'legal' }},domProps:{"textContent":_vm._s(item.text)}})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }